import React, { useState, useEffect } from 'react'

import { useSelector } from 'react-redux'

import { selectUser } from '../../../reducers/UserReducer'
import SmartTable, { SmartTableDataTypes } from '../../../Components/shared/SmartTable'
import { validateFormInput } from '../../../utils'
import Analytics from '../../../utils/analytics'
import FilesManager from '../../../Components/shared/FilesManager'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import { getInstitutionSectors } from '../../../utils/api/institution'

const SectorsView = () => {
  const t = useSelector(selectTranslate)
  const user = useSelector(selectUser)

  const columns = [
    { type: SmartTableDataTypes.ID, key: 'id' },
    {
      type: SmartTableDataTypes.STRING,
      name: t('Name'),
      key: 'name',
      validate: data => validateFormInput('freeText', data, true)
    },
    {
      type: SmartTableDataTypes.STRING,
      name: t('Comment for the students'),
      key: 'comment'
    },
    { type: SmartTableDataTypes.STRING, name: t('common.road'), key: 'emplacement' }
  ]

  const additionalActions = [
    {
      iconName: 'file',
      type: 'primary',
      title: t('Manage files'),
      onClick: s => setSelectedSectorFiles(s)
    }
  ]

  const [sectors, setSectors] = useState([])
  const [selectedSectorFiles, setSelectedSectorFiles] = useState(null)

  useEffect(() => {
    if (user && user.institutions && user.institutions.length > 0) {
      getInstitutionSectors(user, user.institutions[0]).then(json => {
        if (json?.data) {
          setSectors(json.data)
        }
      })
    } else {
      setSectors([])
    }
  }, [user.institutions[0], user.id])

  useEffect(() => {
    Analytics.pageView('/institution-sectors')
  }, [])

  return (
    <>
      <SmartTable
        columns={columns}
        data={sectors}
        additionalActions={additionalActions}
      />
      <FilesManager
        entity={selectedSectorFiles}
        entityName='Sector'
        onClose={() => setSelectedSectorFiles(null)}
        userContextFiltered
        preventChanges
      />
    </>
  )
}

export default SectorsView
